import { Inject, Injectable, InjectionToken } from '@angular/core';

export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
  providedIn: 'root',
  factory: () => localStorage,
});

@Injectable({ providedIn: 'root' })
export class BrowserStorageService {
  constructor(@Inject(BROWSER_STORAGE) public storage: Storage) {}

  get(key: string) {
    return this.storage.getItem(key);
  }

  set(key: string, value: string) {
    this.storage.setItem(key, value);
  }

  remove(key: string) {
    this.storage.removeItem(key);
  }

  clear() {
    this.storage.clear();
  }

  setCookie(key: string, value: string | number | boolean, expiresInDays = 90) {
    if (!this.checkForCookieValue(key, value)) {
      const date = new Date();
      date.setTime(date.getTime() + expiresInDays * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      document.cookie = `${key}=${value}; expires=${expires};path=/;"`;
    }
  }

  checkForCookieValue(key: string, value: string | number | boolean) {
    if (this.checkACookieExists(key)) {
      return document.cookie
        .split(';')
        .some((item) => item.includes(`${key}=${value}`));
    }
    return false;
  }

  getCookieValue(key: string): string | void {
    if (this.checkACookieExists(key)) {
      return (
        document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)')?.pop() ||
        ''
      );
    }
    return;
  }

  private checkACookieExists(key: string) {
    return document.cookie
      .split(';')
      .some((item) => item.trim().startsWith(`${key}=`));
  }
}
